var _circle, _path, _path2, _circle2, _circle3, _circle4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualFunds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1062 28.1962C34.5062 28.1962 35.6062 26.1962 36.1062 25.1962C36.2729 25.0295 36.3062 24.7962 35.1062 25.1962C33.6062 25.6962 33.1062 27.1962 32.1062 27.6962C31.1062 28.1962 31.1059 27.1962 29.1059 28.1962C27.1059 29.1962 26.7894 32.0638 27.1059 32.6962C27.6064 33.6962 27.1065 34.6962 27.1062 35.6962L31.1059 35.6962C31.106 34.8628 31.1062 33.0962 31.1059 32.6962C31.1056 32.1961 34.6062 29.6962 35.6062 29.6962C36.6062 29.6962 37.6062 25.6962 37.6062 25.1962C37.6062 24.6962 37.6062 23.1962 37.6062 22.1962C37.6062 21.1962 37.1062 20.6962 36.6062 21.1962C36.2062 21.5962 36.1062 23.0295 36.1062 23.6962",
    stroke: "#183883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 28.1962C17.1002 28.1962 16.0002 26.1962 15.5002 25.1962C15.3336 25.0295 15.3002 24.7962 16.5002 25.1962C18.0002 25.6962 18.5002 27.1962 19.5002 27.6962C20.5002 28.1962 20.5006 27.1962 22.5006 28.1962C24.5006 29.1962 24.8171 32.0638 24.5006 32.6962C24 33.6962 24.4999 34.6962 24.5002 35.6962L20.5006 35.6962C20.5004 34.8628 20.5003 33.0962 20.5006 32.6962C20.5009 32.1961 17.0002 29.6962 16.0002 29.6962C15.0002 29.6962 14.0002 25.6962 14.0002 25.1962C14.0002 24.6962 14.0002 23.1962 14.0002 22.1962C14.0002 21.1962 14.5002 20.6962 15.0002 21.1962C15.4002 21.5962 15.5002 23.0295 15.5002 23.6962",
    stroke: "#183883"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 19.5,
    r: 2,
    stroke: "#183883"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 17,
    r: 1.5,
    stroke: "#183883"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 22.5,
    r: 3,
    fill: "white",
    stroke: "#183883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4744 22.3434L26.418 22.5309H25.0778L25.1332 22.3434H26.4744ZM25.9322 24L25.0948 23.0167L25.0927 22.8793H25.4592C25.57 22.8793 25.6644 22.8633 25.7425 22.8313C25.8207 22.7987 25.8803 22.7504 25.9215 22.6864C25.9634 22.6225 25.9844 22.5433 25.9844 22.4489C25.9844 22.3097 25.9407 22.2003 25.8533 22.1207C25.7667 22.0405 25.6424 22.0004 25.4805 22.0004H25.0778L25.1332 21.8182H25.4805C25.6367 21.8182 25.7674 21.8452 25.8725 21.8991C25.9783 21.9531 26.0579 22.0277 26.1112 22.1229C26.1651 22.2173 26.1921 22.326 26.1921 22.4489C26.1921 22.5639 26.1662 22.6676 26.1143 22.7599C26.0632 22.8516 25.984 22.9244 25.8768 22.9783C25.7702 23.0316 25.6342 23.0582 25.4688 23.0582H25.392L26.1804 23.984V24H25.9322ZM26.4819 21.8182L26.4265 22.0057L25.2972 22.0004L25.3484 21.8182H26.4819Z",
    fill: "#183883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualFunds);
export default __webpack_public_path__ + "static/media/MutualFunds.7ea7fd97edab7ddaeb65356ebed9c614.svg";
export { ForwardRef as ReactComponent };